<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import RedSpot from '@/components/RedSpot.vue';
import GalleryBeforeAfter from '@/components/ui/GalleryBeforeAfter.vue';
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  hasTitle,
  items,
  hasItems,
  redSpot,
  hasRedSpot,
  hasAnyContent,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <RedSpot
      v-if="hasRedSpot"
      :position-vertical="redSpot.vertical"
      :position-horizontal="redSpot.horizontal"
    />
    <div class="container">
      <div class="gallery-block">
        <h2
          v-if="hasTitle"
          class="mb-0 gallery-block__title h2"
          :class="[backgroundColor === 'black' ? 'white' : 'black']"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="title"
        ></h2>
        <GalleryBeforeAfter
          v-if="hasItems"
          :id="`gallery-${id}`"
          :items="items"
          :background-color="backgroundColor"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.gallery-block {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0 auto;
    text-align: center;
  }
}
</style>
